import Vue from 'vue';
import Router from 'vue-router';

import CalendarIndex from "@/views/calendar/CalendarIndex";
import CalendarConfirmed from "@/views/calendar/CalendarConfirmed";
import CalendarDeleted from "@/views/calendar/CalendarDeleted";
import CalendarQueued from "@/views/calendar/CalendarQueued";
import CalendarDay from "@/views/calendar/CalendarDay";
import CalendarWeek from "@/views/calendar/CalendarWeek";
import CalendarMonth from "@/views/calendar/CalendarMonth";
import CalendarSchedule from "@/views/calendar/CalendarSchedule";
import CalendarTrack from "@/views/calendar/CalendarTrack";
// import Thread from "@/views/message/Thread";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'calendar-index',
            component: CalendarIndex,
            props: {default: true, view: 'index'},
        },
        {
            path: '/queued',
            name: 'calendar-queued',
            component: CalendarQueued,
            props: {default: true, view: 'queued'},
        },
        {
            path: '/confirmed',
            name: 'calendar-confirmed',
            component: CalendarConfirmed,
            props: {default: true, view: 'confirmed'},
        },
        {
            path: '/day',
            name: 'calendar-day',
            component: CalendarDay,
            props: {default: true, view: 'day'},
        },
        {
            path: '/week',
            name: 'calendar-week',
            component: CalendarWeek,
            props: {default: true, view: 'week'},
        },
        {
            path: '/month',
            name: 'calendar-month',
            component: CalendarMonth,
            props: {default: true, view: 'month'},
        },
        {
            path: '/schedule',
            name: 'calendar-schedule',
            component: CalendarSchedule,
            props: {default: true, view: 'schedule'},
        },
        {
            path: '/track/:trackId',
            name: 'calendar-track',
            component: CalendarTrack,
            props: {default: true, view: 'track'},
        },
        {
            path: '/deleted',
            name: 'calendar-deleted',
            component: CalendarDeleted,
            props: {default: true, view: 'deleted'},
        },
    ]
});

export default router;